import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ClientType } from 'src/app/utils/const';
import { MeesmaService } from 'src/app/shared/services/meesma.service';
import { AppService } from 'src/app/shared/services/app.service';

export const ProposerGuardCanActivate = async (route: ActivatedRouteSnapshot) => {
  const router = inject(Router)
  const meesmaService = inject(MeesmaService)
  const appService = inject(AppService)
  const client = sessionStorage.getItem("client") || "hub"
  if(client != ClientType.MEESMA && !route.queryParams['uuid'] ) {
    return false
  } 
  if((client == ClientType.MEESMA && meesmaService.isAuthenticated)
    || appService.isAuthenticated) return true
  else {
    await router.navigate(['/proposer'], {
      queryParams: route.queryParams,
      replaceUrl: true
    })
    return false
  }
}


